import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Functions } from 'src/app/core/helpers/functions';
import { CouponCustomerPrizeRequest, CouponCustomerPrizeResponse } from 'src/app/core/models/coupon-customer-prize/coupon-customer-prize';
import { CouponCustomerPrizeService } from 'src/app/core/services/ge-coupon-customer-prize/ge-coupon-customer-prize.service';
declare function sendData(data: string): string;

@Component({
    selector: 'app-coupon-prize',
    templateUrl: './coupon-prize.component.html',
    styleUrls: ['./coupon-prize.component.css'],
})
export class CouponPrizeComponent implements OnInit {
    eventId = '';
    claimerShopDid: string | null = '';
    couponCustomerPrizeResponse: CouponCustomerPrizeResponse | undefined;

    constructor(
        private couponCustomerPrizeService: CouponCustomerPrizeService,
        private activeRoute: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        this.eventId = this.activeRoute.snapshot.params['eventId'];
        this.claimerShopDid = sessionStorage.getItem('claimer_shop_did');
        this.onPrize();
    }

    onPrize() {
        const couponCustomerPrizeRequest: CouponCustomerPrizeRequest = {
            event_id: this.eventId,
            language: Functions.getDefaultLanguage(),
        };
        this.couponCustomerPrizeService
            .postPrize(couponCustomerPrizeRequest)
            .subscribe((result) => {
                if (result.statusCode === 1000) {
                    this.couponCustomerPrizeResponse = result;
                    const couponCustomerPrize = {
                        type: 'COUPON',
                        ticketType: 'COUPON',
                        shopGroupId: this.couponCustomerPrizeResponse.coupon_prize.shop_group_id,
                        shopDid: this.couponCustomerPrizeResponse.coupon_prize.shop_did,
                        masterCouponId: this.couponCustomerPrizeResponse.coupon_prize.master_coupon_id,
                        claimerShopDid: this.claimerShopDid,
                        couponAmount: this.couponCustomerPrizeResponse.coupon_prize.coupon_amount,
                    };
                    sendData(JSON.stringify(couponCustomerPrize));
                }
            }
        );
    }
}
